export const UI_SETTINGS = {
	buttonHoverAnimation: true,
} as const;
